
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonOpen as ObiThreewayAcuatorPistonOpenElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-open.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonOpen = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-open',
   elementClass: ObiThreewayAcuatorPistonOpenElement,
   events: {
     
   }
  });
 
 